<template>
  <div v-if="canExport">
    <json-excel
        class   = "btn btn-default"
        :name    = "nameFile"
        :title  = "title"
        :fields = "json_fields"
        :escapeCsv = "true"
        type    = "csv"
        :before-generate = "beforeGenerate"
        :before-finish = "beforeFinish"
        :fetch  = "doExport">
        <el-tooltip
          placement="top"
          :content="$t('information.export_lesson_detail_button')"
        >
          <chip class="export-lesson-detail" v-loading.fullscreen.lock="exportLoading">
            {{$t('common.lesson_detail')}}
          </chip>
        </el-tooltip>
    </json-excel>
  </div>
</template>

<script>
  import showNoReportDataWarning from '@/components/common/mixins/noReportData'
  import { isSessionExpireError } from '@/utils/sessionExpireErr'
  import Chip from '@/components/common/Chip'
  import JsonExcel from '@/components/lib/JsonExcel'
  import { format, toDate, startOfMonth } from 'date-fns'
  import { mapGetters, mapActions, mapState } from 'vuex'
  import { warningMessage, successMessage } from '@/utils/messages'
  import {
  pathOr, length, join, prop, compose, concat, __
  } from 'ramda'
  export default {
    mixins: [ showNoReportDataWarning ],
    components: {
      Chip,
      JsonExcel
    },
    props: {
      startDate: {
        default: () => startOfMonth(Date.now())
      },
      endDate: {
        default: () => toDate(Date.now())
      },
      scope: {
        default: 'daily'
      },
      canExport: {
          default: false
      }
    },
    data() {
      return {
        json_fields: {
            'Student Name': 'student_name',
            'Student Email': 'student_email',
            'Lesson Date': 'date',
            'Lesson Score': 'overall_native_score',
            'Module Name': 'module_name',
            'Lesson Name': 'lesson_name',
            'Difficulty Level': 'difficulty_level'
        },
        exportLoading: false,
      }
    },
    destroyed () {
      this.$store.dispatch('classes/resetExportLessonDetailData')
    },
    methods: {
      getAllExportData(options) {
        return this.getExportLessonDetailData(options)
          .catch((err) => {
            if(!isSessionExpireError(err))
              this.showNoReportDataWarning()
          })
      },
      ...mapActions({getCurrentClassAllUsers: 'classes/getCurrentClassAllUsers'}),
      ...mapActions('classes',[
        "getExportLessonDetailData",
      ]),
      async doExport() {
        let studentRequests = [];
        try {
          if (!length(this.exportLessonDetailData)) {
            await this.getCurrentClassAllUsers();
            for (var i = 0; i < this.currentClassAllStudent.length; i++) {
                let student = this.currentClassAllStudent[i]['user'];
                let options = {
                  student: student,
                  from: this.startDate,
                  to: this.endDate,
                }
                studentRequests.push(this.getAllExportData(options))
            }
            return Promise.all(studentRequests).then((rsp) => {
              if (this.exportLessonDetailData.length > 0) {
                return this.exportLessonDetailData.map((data) => {
                  return {...data, date: data['date'] ? `${data['date'].split(' ')[0]} ${format(new Date(data['date'].split(' ')[1]), 'dd MMM yyyy')}` : ''}
                }); 
              } else {
                this.handleWithoutData()
              }
            })
          }
          try {
            this.$gtag.event(`${document.title}-export lesson detail`, {
              'category': `Export`,
              'label': `Lesson Detail`
            });
          }
          catch (error) {
            error
          }
          return this.exportLessonDetailData.map((data) => {
            return {...data, date: data['date'] ? `${data['date'].split(' ')[0]} ${format(new Date(data['date'].split(' ')[1]), 'dd MMM yyyy')}` : ''}
          });
        } catch(error) {
            return error
        }
      },
      handleWithoutData() {
        const message = this.$t('common.no_lessons_in_periods')
        this.exportLoading = false;
        successMessage(this.$t(message))(this);
      },
      beforeGenerate(){
        return this.exportLoading = true;
      },
      beforeFinish(){
        return this.exportLoading = false;
      }
    },
    computed: {
      ...mapState('classes', [
        'exportLessonDetailData'
      ]),
      ...mapGetters({
        getCurrentClass: 'classes/getCurrentClass',
        currentClassAllStudent: 'classes/getCurrentClassAllStudent',
      }),
      ...mapGetters('students', [
        'paginateStudents',
      ]),
      title() {
        const formatedStartDate = format(new Date(this.startDate), 'dd MMM yyyy')
        const formatedEndDate = format(new Date(this.endDate), 'dd MMM yyyy')
        let titleTime = `${formatedStartDate} - ${formatedEndDate}`
        return [`${this.getCurrentClass.name} Lesson Detail Report` , titleTime]
      },
      nameFile: compose(
        concat(__, '.csv'),
        join(' '),
        prop('title')
      )
    },
    watch: {
    },
  }
</script>

<style lang="scss" scoped>
@import '../../scss/_colors.scss';
.export-lesson-detail{
  padding: 11px 11px;
}
</style>
